import { PageShell } from '../components/PageShell'
import { ServicesTabContent } from '../panels/ServicesTab'
import { Store } from 'lucide-react'

export function ServicesPage() {
  return (
    <PageShell
      pageId="services"
      title="Gestion Comercial"
      icon={<Store size={22} />}
    >
      <ServicesTabContent />
    </PageShell>
  )
}
